import { render, staticRenderFns } from "./add-thoughts.vue?vue&type=template&id=14b84607"
import script from "./add-thoughts.vue?vue&type=script&lang=js"
export * from "./add-thoughts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports